module.exports = __webpack_public_path__ + "static/media/18.f4b3886e.mp3";